import { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import { updateAppVersion, getAppVersions } from "../../actions";
import { createDiscount, deleteDiscount, fetchDiscountList } from "../../actions/discount";
import { validateDiscount, validateDiscountOnChange } from "../../validators";

export const useDiscountHook = () => {
   const updatedPaginationData = {
      limit: 10,
      skip: 0,
      page: 0,
      total: 0
   }
   const [paginationData, setPaginationData] = useState(updatedPaginationData)
   const [isEdit, setIsEdit] = useState(false);
   const [isLoading, setIsLoading] = useState(false);
   const [errorMessages, setErrorMessages] = useState({});
   const [tableKey, setTableKey] = useState(0)
   const [showAddDiscountModal, setShowAddDiscountModal] = useState(false)
   const [showDeleteDiscountModal, setShowDeleteDiscountModal] = useState(false)
   const [deleteDiscountData, setDeleteDiscountData] = useState({})
   const [deleteDiscountEditData, setDeleteDiscountEditData] = useState({})
   const [discountList, setDiscountList] = useState({})

   useEffect(() => {
      getDiscountList({ ...updatedPaginationData })
   }, [])

   const handleDeleteDiscount = async (discountId) => {
      const deleteDiscountResp = await deleteDiscount(discountId)
      const deleteDiscountData = deleteDiscountResp.data
      if (deleteDiscountData.success) {
         toggleDeleteDiscountModal()
         getDiscountList()
      }
   }

   const getDiscountList = async (updatedPaginationData = { ...paginationData }) => {
      try {
         setIsLoading(true)
         const discountQueryParams = {
            limit: updatedPaginationData.limit || 10,
            skip: updatedPaginationData.skip || 0,
         }
         const fetchDiscountListResp = await fetchDiscountList(discountQueryParams)
         const discountsResp = fetchDiscountListResp.data
         if (discountsResp.success) {
            setDiscountList(discountsResp.ResponseData)
         }
         setPaginationData({
            ...updatedPaginationData,
            total: discountsResp.ResponseData.totalCount || 0,
         })
      } catch (error) {
         console.log(error);
      } finally {
         setIsLoading(false)
      }
   }

   const onPageChange = (activePage, selectedSize) => {
      console.log(activePage, selectedSize, "::activePage, selectedSize")
      const updatedPaginationData = {
         ...paginationData,
         page: activePage,
         limit: selectedSize,
         skip: selectedSize * activePage
      }
      getDiscountList({ ...updatedPaginationData })
   }

   const toggleAddDiscountModal = (editDiscount, edit = false) => {
      setShowAddDiscountModal(!showAddDiscountModal)
      setErrorMessages({});
      setIsEdit(edit)
      setDeleteDiscountEditData(editDiscount)
      // setDiscountData(initialDiscountData)
   }

   const toggleDeleteDiscountModal = (deleteDiscount, edit = false) => {
      setDeleteDiscountData(deleteDiscount)
      setShowDeleteDiscountModal(!showDeleteDiscountModal)
   }

   return {
      isEdit,
      tableKey,
      paginationData,
      isLoading,
      discountList,
      deleteDiscountData,
      showAddDiscountModal,
      showDeleteDiscountModal,
      errorMessages,
      getDiscountList,
      onPageChange,
      deleteDiscountEditData,
      handleDeleteDiscount,
      toggleAddDiscountModal,
      toggleDeleteDiscountModal
   }
}